import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, ContentChildren, NgModule } from '@angular/core';
import * as i4 from '@capturum/ui/api';
import { CapturumTemplateDirective, CapturumSharedModule } from '@capturum/ui/api';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i3 from 'primeng/tooltip';
import { TooltipModule } from 'primeng/tooltip';
function CapturumSidebarMenuComponent_div_6_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.title, " ");
  }
}
function CapturumSidebarMenuComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 7);
    i0.ɵɵelement(2, "img", 8);
    i0.ɵɵtemplate(3, CapturumSidebarMenuComponent_div_6_div_3_Template, 2, 1, "div", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("routerLink", ctx_r1.homePageUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r1.logoUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isExpanded);
  }
}
const _c0 = function (a0, a1, a2, a3) {
  return {
    item: a0,
    index: a1,
    last: a2,
    first: a3
  };
};
function CapturumSidebarMenuComponent_ng_container_8_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementContainer(1, 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customTemplate_r12 = ctx.ngIf;
    const ctx_r13 = i0.ɵɵnextContext();
    const menu_r5 = ctx_r13.$implicit;
    const i_r6 = ctx_r13.index;
    const last_r7 = ctx_r13.last;
    const first_r8 = ctx_r13.first;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c0, menu_r5, i_r6, last_r7, first_r8))("ngTemplateOutlet", customTemplate_r12);
  }
}
function CapturumSidebarMenuComponent_ng_container_8_ng_template_3_li_0_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 18);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "observablePipe");
  }
  if (rf & 2) {
    const menu_r5 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind1(2, 3, menu_r5.label)), i0.ɵɵsanitizeHtml);
  }
}
function CapturumSidebarMenuComponent_ng_container_8_ng_template_3_li_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 15);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "observablePipe");
    i0.ɵɵelement(3, "i", 16);
    i0.ɵɵtemplate(4, CapturumSidebarMenuComponent_ng_container_8_ng_template_3_li_0_span_4_Template, 3, 5, "span", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menu_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLinkActiveOptions", ctx_r14.routerOptions)("routerLink", "/" + menu_r5.routerLink)("pTooltip", i0.ɵɵpipeBind1(1, 8, i0.ɵɵpipeBind1(2, 10, menu_r5 == null ? null : menu_r5.label)))("tooltipDisabled", ctx_r14.tooltipDisabled)("tooltipPosition", ctx_r14.tooltipPosition);
    i0.ɵɵattribute("data-test", menu_r5.routerLink);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("className", menu_r5.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.isExpanded);
  }
}
function CapturumSidebarMenuComponent_ng_container_8_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CapturumSidebarMenuComponent_ng_container_8_ng_template_3_li_0_Template, 5, 12, "li", 14);
  }
  if (rf & 2) {
    const menu_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", !(menu_r5 == null ? null : menu_r5.hidden));
  }
}
function CapturumSidebarMenuComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CapturumSidebarMenuComponent_ng_container_8_li_1_Template, 2, 7, "li", 11);
    i0.ɵɵpipe(2, "columnTemplate");
    i0.ɵɵtemplate(3, CapturumSidebarMenuComponent_ng_container_8_ng_template_3_Template, 1, 1, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const _r10 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind2(2, 2, ctx_r2.templates, "item"))("ngIfElse", _r10);
  }
}
function CapturumSidebarMenuComponent_div_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("classList", ctx_r19.collapseIcon);
  }
}
function CapturumSidebarMenuComponent_div_9_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 21);
  }
  if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("classList", ctx_r21.expandIcon);
  }
}
function CapturumSidebarMenuComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function CapturumSidebarMenuComponent_div_9_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r23);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.toggleExpanded());
    });
    i0.ɵɵtemplate(1, CapturumSidebarMenuComponent_div_9_ng_container_1_Template, 2, 1, "ng-container", 11);
    i0.ɵɵtemplate(2, CapturumSidebarMenuComponent_div_9_ng_template_2_Template, 1, 1, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const _r20 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isExpanded)("ngIfElse", _r20);
  }
}
const _c1 = [[["", "before", ""]], [["", "brand", ""]], [["", "after", ""]]];
const _c2 = function (a0, a1) {
  return {
    "cap-sidebar--collapsed": a0,
    "cap-sidebar--dark": a1
  };
};
const _c3 = ["[before]", "[brand]", "[after]"];
var TooltipPositions = /*#__PURE__*/function (TooltipPositions) {
  TooltipPositions["RIGHT"] = "right";
  TooltipPositions["LEFT"] = "left";
  TooltipPositions["TOP"] = "top";
  TooltipPositions["BOTTOM"] = "bottom";
  return TooltipPositions;
}(TooltipPositions || {});
let CapturumSidebarMenuComponent = /*#__PURE__*/(() => {
  class CapturumSidebarMenuComponent {
    constructor() {
      this.collapseIcon = 'fas fa-chevron-left';
      this.expandIcon = 'fas fa-chevron-right';
      this.homePageUrl = `/`;
      this.routerOptions = {
        exact: false
      };
      this.isExpanded = true;
      this.darkLayout = false;
      this.tooltipDisabled = true;
      this.tooltipPosition = TooltipPositions.RIGHT;
      this.onExpand = new EventEmitter();
    }
    toggleExpanded() {
      if (this.expandable) {
        this.isExpanded = !this.isExpanded;
        this.onExpand.emit(this.isExpanded);
      }
    }
    static {
      this.ɵfac = function CapturumSidebarMenuComponent_Factory(t) {
        return new (t || CapturumSidebarMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumSidebarMenuComponent,
        selectors: [["cap-sidebar-menu"]],
        contentQueries: function CapturumSidebarMenuComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CapturumTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        inputs: {
          logoUrl: "logoUrl",
          title: "title",
          expandable: "expandable",
          collapseIcon: "collapseIcon",
          expandIcon: "expandIcon",
          homePageUrl: "homePageUrl",
          menus: "menus",
          routerOptions: "routerOptions",
          isExpanded: "isExpanded",
          darkLayout: "darkLayout",
          tooltipDisabled: "tooltipDisabled",
          tooltipPosition: "tooltipPosition"
        },
        outputs: {
          onExpand: "onExpand"
        },
        ngContentSelectors: _c3,
        decls: 11,
        vars: 7,
        consts: [[1, "cap-sidebar", 3, "ngClass"], [1, "cap-sidebar__brand"], ["brand", ""], [4, "ngIf"], [1, "cap-sidebar__menus"], [4, "ngFor", "ngForOf"], ["class", "cap-sidebar__button", 3, "click", 4, "ngIf"], [1, "brand-wrapper", 3, "routerLink"], ["alt", "logo", 3, "src"], ["class", "cap-sidebar__title", 4, "ngIf"], [1, "cap-sidebar__title"], [4, "ngIf", "ngIfElse"], ["defaultMenuItem", ""], [3, "ngTemplateOutletContext", "ngTemplateOutlet"], ["routerLinkActive", "active", "tooltipStyleClass", "cap-sidebar-tooltip", 3, "routerLinkActiveOptions", "routerLink", "pTooltip", "tooltipDisabled", "tooltipPosition", 4, "ngIf"], ["routerLinkActive", "active", "tooltipStyleClass", "cap-sidebar-tooltip", 3, "routerLinkActiveOptions", "routerLink", "pTooltip", "tooltipDisabled", "tooltipPosition"], [3, "className"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], [1, "cap-sidebar__button", 3, "click"], ["collapsedButton", ""], [3, "classList"]],
        template: function CapturumSidebarMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementStart(2, "div", 1)(3, "div", null, 2);
            i0.ɵɵprojection(5, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, CapturumSidebarMenuComponent_div_6_Template, 4, 3, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "ul", 4);
            i0.ɵɵtemplate(8, CapturumSidebarMenuComponent_ng_container_8_Template, 5, 5, "ng-container", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, CapturumSidebarMenuComponent_div_9_Template, 4, 2, "div", 6);
            i0.ɵɵprojection(10, 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const _r0 = i0.ɵɵreference(4);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c2, !ctx.isExpanded, ctx.darkLayout));
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngIf", !(_r0 == null ? null : _r0.children == null ? null : _r0.children.length));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.menus);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.expandable);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2.RouterLink, i2.RouterLinkActive, i3.Tooltip, i1.AsyncPipe, i4.ObservablePipe, i4.CapturumColumnTemplatePipe],
        encapsulation: 2
      });
    }
  }
  return CapturumSidebarMenuComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumSidebarMenuModule = /*#__PURE__*/(() => {
  class CapturumSidebarMenuModule {
    static {
      this.ɵfac = function CapturumSidebarMenuModule_Factory(t) {
        return new (t || CapturumSidebarMenuModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumSidebarMenuModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule, CapturumSharedModule, TooltipModule]
      });
    }
  }
  return CapturumSidebarMenuModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumSidebarMenuComponent, CapturumSidebarMenuModule };
